export default "__VITE_ASSET__BFxxHWaz__"